import React from 'react'
import { useState } from 'react'
import { backendUrl } from '../App'
import { toast } from 'react-toastify'
import { Eye, EyeOff, LogIn } from 'lucide-react'

const Login = ({ setToken }) => {
    const [email, setEmail] = useState('trendhive@admin.com')
    const [password, setPassword] = useState('12345678')
    const [show, setShow] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(backendUrl + "/api/user/adminpanel",
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    method: "POST",
                    body: JSON.stringify({ email, password })
                })
            const data = await response.json();
            if (data.sucess) {
                setToken(data.token);
            } else {
                toast.error(data.msg);
            }

        } catch (error) {
            console.error(error)
        }
    }
    return (
        <div className='flex justify-center items-center h-[100vh] w-full'>
            <div className='flex flex-col sm:w-[400px] w-[320px] shadow-slate-300 shadow-lg p-8 rounded-lg'>
                <h1 className='text-2xl text-black pb-4 font-semibold'>Admin Panel</h1>
                <form onSubmit={handleSubmit}>
                    <div>
                        <p className='text-gray-600 text-lg pb-1.5 '>Email Address</p>
                        <input className='border border-gray-400 rounded-md px-4 py-2 text-lg w-full mb-2' value={email ? email : 'trendhive@admin.com'} type="email" name="" id="" placeholder='Enter your Email' required onChange={(e) => { setEmail(e.target.value) }} />
                    </div>
                    <div>
                        <p className='text-gray-600 text-lg pb-1.5 '>Password</p>
                        <div className='flex flex-row relative'>
                            <input className='border border-gray-400 rounded-md px-4 py-2 text-lg w-full mb-2' type={show ? "text" : "password"} name="" id="" placeholder='Enter your password' value={password ? password : '12345678'} required onChange={(e) => { setPassword(e.target.value) }} />
                            <div className='w-8 h-8 absolute right-2 top-2 cursor-pointer' alt="" onClick={() => setShow(!show)} >{show ? (<Eye width={28} />) : (<EyeOff width={28} />)}</div>
                        </div>
                    </div>
                    <button className='inline-flex justify-center items-center w-full bg-black text-lg px-3 py-2 rounded-lg text-white mt-3' type='submit'>Login<LogIn width={18} className='ml-2' /></button>
                </form>
            </div>
        </div>
    )
}

export default Login